// src/utils/auth.js

import { DESKTOP_UNREAD_REMINDER_KEY } from "../constants/desktopUnreadReminder";
import { clearLessonCacheSessionKey } from "./secureLessonDocumentCache";

export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

// Lưu token + user + modules
export const login = (token, user, modules) => {
  clearLessonCacheSessionKey();
  localStorage.setItem("token", token);
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  if (modules) {
    localStorage.setItem("modules", JSON.stringify(modules));
  }
};

// Xóa token + user + modules khi logout
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("modules");
  try {
    sessionStorage.removeItem(DESKTOP_UNREAD_REMINDER_KEY);
  } catch (_) {
    /* ignore */
  }
  clearLessonCacheSessionKey();
};

/**
 * Lấy thông tin user từ localStorage
 */
export const getCurrentUser = () => {
  const user = localStorage.getItem("user");
  if (user) {
    try {
      return JSON.parse(user);
    } catch (e) {
      console.error("Không thể parse user từ localStorage:", e);
    }
  }
  return null;
};

/**
 * Lấy danh sách modules từ localStorage
 */
export const getCurrentModules = () => {
  const modules = localStorage.getItem("modules");
  if (modules) {
    try {
      return JSON.parse(modules);
    } catch (e) {
      console.error("Không thể parse modules từ localStorage:", e);
    }
  }
  return [];
};

/** Duy nhất tài khoản này được đăng nhập / mở lại app khi đang bảo trì. */
export const MAINTENANCE_BYPASS_EMAIL = "administrator@hamesoft.com";

export const canBypassAppMaintenance = () => {
  const user = getCurrentUser();
  const email = user?.email?.trim().toLowerCase();
  return email === MAINTENANCE_BYPASS_EMAIL.toLowerCase();
};

/** Admin hệ thống — mở báo cáo bổ sung, kết xuất công việc, v.v. */
export const isTasksAdminEmail = (user = getCurrentUser()) => {
  const email = String(user?.email || "").trim().toLowerCase();
  return email === MAINTENANCE_BYPASS_EMAIL.toLowerCase();
};

/**
 * Giải mã JWT và lấy payload (nếu cần check roles/permissions trực tiếp từ token)
 */
export const getTokenPayload = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (e) {
    console.error("Không thể giải mã token:", e);
    return null;
  }
};

/**
 * Đồng bộ localStorage.modules với payload JWT (chỉ khi JWT còn modules — token cũ).
 * Token mới không nhồi modules; quyền FE lấy từ login/refresh body.
 */
export const syncModulesFromToken = () => {
  const payload = getTokenPayload();
  if (!payload || !Array.isArray(payload.modules) || payload.modules.length === 0) {
    return false;
  }
  localStorage.setItem("modules", JSON.stringify(payload.modules));
  return true;
};
